import React, { useEffect, useState } from "react";
import { BsChevronRight, BsChevronDown } from "react-icons/bs";
import treeViewCollapse from '../../assets/svg/Tree_view_collapse.svg';
import {IoMdArrowDropdown} from 'react-icons/io';
import { IconButton } from "@mui/material";
import { FaAnglesLeft } from "react-icons/fa6";
import COLORS from "../styles/COLORS";

export const TagDetails = ({tag,colDfns,setShowCollapse}) => {
    const [tagColDfns,setTagColDfns] = useState(null);
    //const [colHdrs,setColHdrs] = useState(null);
    const [hiddenHdrs, setHiddenHdrs] = useState([]);
    useEffect(()=>{
        const tempTagColDfns = colDfns?.filter((col)=>{
                return col.headerName!==undefined && col.headerName!==null 
                    && col.headerName!=='' && col.headerName!=='#'
            });
         const tempColHdrs = tempTagColDfns.map(col=>{
             return col.headerName;
         })
         setHiddenHdrs(tempColHdrs);
         setTagColDfns(tempTagColDfns);
         // setColHdrs(tempColHdrs);
        // console.log('tempColHdrs',tempColHdrs)
    },[colDfns]);

    const hideChildTags = (headerName) => {
        let tempHiddenHdrs = [...hiddenHdrs];
        
        if (!tempHiddenHdrs.includes(headerName)) {
            tempHiddenHdrs.push(headerName);
        } else {
            tempHiddenHdrs = tempHiddenHdrs.filter(hName => headerName !== hName)
        }
        //let tempHiddenHdrs = [...colHdrs];
        //tempHiddenHdrs = tempHiddenHdrs.filter(hdrName => {return hdrName!==headerName});
        setHiddenHdrs(tempHiddenHdrs);
    }


    const isHdrHidden = (headerName) => {
        const tempHiddenHdrs = [...hiddenHdrs];
        return tempHiddenHdrs.includes(headerName);
    }

    const getGrpChildren = (gChildren) => {
        const grpCh = gChildren.map((col,index)=>{
            return(
            <div className="row" key={index} style={{marginBottom:5,display:col.hide?'none':'flex'}}>
                <label className="tag-details-ch-hdr-lbl  col-sm-6">{col.headerName}</label>
                <label className="tag-details-ch-hdr-val  col-sm-6">{tag[col.field]}</label>
            </div>
            )
        })
    return grpCh;
    }
    return(
        <div>
            <div style={{ display: 'flex', marginBottom:3, marginTop:5}}>
                <label className='tag-details-tag-heading'>{tag.tag_number}</label>
                {/* <img src={treeViewCollapse} className='tag-details-collapse' onClick={()=>setShowCollapse(true)} /> */}
                <IconButton onClick={() => setShowCollapse(true)} size='small' >
                    <FaAnglesLeft />
                </IconButton>
            </div>
            <div className="tag-details-main-scroll">
                {tagColDfns!==null && tagColDfns.map((group,index)=>{
                    const gChildren = getGrpChildren(group.children);
                    return (
                        <div key={index} style={{position:'relative'}}>
                            <label className="tag-details-grp-hdr-lbl">
                                <input className='custom-chkbox-green' type='checkbox' checked={true} readOnly />
                                <span className="side-bar-label ">{group.headerName}</span>
                                <span style={{marginLeft:'auto'}}>
                                    {isHdrHidden(group.headerName) && 
                                        <BsChevronRight className='mx-2 tag-detail-arrow-head' onClick={()=>hideChildTags(group.headerName)} />
                                    }
                                    {!isHdrHidden(group.headerName) && 
                                        <BsChevronDown className='mx-2 tag-detail-arrow-head' onClick={()=>hideChildTags(group.headerName)} />
                                    }
                                </span>
                                
                            </label>
                            <div className="tag-details-chldn-div-dtd">
                                {!isHdrHidden(group.headerName) && <div className="tag-details-chldn-div">{gChildren}</div>}
                            </div>
                            {tagColDfns.length-1===index && !isHdrHidden(group.headerName) && 
                                <IoMdArrowDropdown style={{position:'absolute',fontSize:18,color:COLORS.green,margin:3}} />
                            }
                        </div>
                    )})
            }
            
            </div>
        </div>
    )
            
}